export default "__VITE_ASSET__2bc596ea__"